import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";

// Components
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import PersonalSection from "./components/PersonalSection";
import TechProjectsSection from "./components/TechProjectsSection";
import BlogSection from "./components/BlogSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import AdminApp from "./components/AdminApp";
import ProjectsPage from "./components/ProjectsPage";
import BlogsPage from "./components/BlogsPage";
import VisitorTracker from "./components/VisitorTracker";
import GDPRConsent from "./components/GDPRConsent";
import { SidebarAd, BannerAd, ResponsiveAd } from "./components/AdSense";
import { PopupProvider } from "./contexts/PopupContext";
import { SectionAnimationProvider } from "./contexts/SectionAnimationContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const [gdprConsent, setGdprConsent] = useState(null);
  const [adsEnabled, setAdsEnabled] = useState(false);

  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  const loadAdSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings/ads`);
      setAdsEnabled(response.data.ads_enabled);
    } catch (e) {
      console.error('Error loading ad settings:', e);
      setAdsEnabled(false); // Default to disabled if can't load
    }
  };

  useEffect(() => {
    helloWorldApi();
    loadAdSettings();
  }, []);

  const handleConsentChange = (consent) => {
    setGdprConsent(consent);
  };

  return (
    <div className="min-h-screen bg-bg-page">
      <Header />
      
      {/* Banner Ad at top */}
      {gdprConsent?.marketing && adsEnabled && (
        <div className="bg-gray-50 border-b border-gray-200 py-2">
          <div className="container mx-auto px-6 text-center">
            <BannerAd />
          </div>
        </div>
      )}
      
      <main className="relative">
        {/* Sidebar Ad - Fixed Position */}
        {gdprConsent?.marketing && adsEnabled && (
          <div className="hidden xl:block fixed right-4 top-1/2 transform -translate-y-1/2 z-30">
            <SidebarAd />
          </div>
        )}
        
        <HeroSection />
        
        {/* Ad between sections */}
        {gdprConsent?.marketing && adsEnabled && (
          <div className="py-8 bg-gray-50">
            <div className="container mx-auto px-6 text-center">
              <ResponsiveAd />
            </div>
          </div>
        )}
        
        <PersonalSection />
        <TechProjectsSection />
        
        {/* Another ad between sections */}
        {gdprConsent?.marketing && adsEnabled && (
          <div className="py-8 bg-gray-50">
            <div className="container mx-auto px-6 text-center">
              <ResponsiveAd />
            </div>
          </div>
        )}
        
        <BlogSection />
        <ContactSection />
      </main>
      
      <Footer />
      
      {/* GDPR Consent Banner */}
      <GDPRConsent onConsentChange={handleConsentChange} />
      
      {/* Visitor Tracking (only if consent given) */}
      {gdprConsent?.analytics && <VisitorTracker />}
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <PopupProvider>
        <SectionAnimationProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin" element={<AdminApp />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/blogs" element={<BlogsPage />} />
            </Routes>
          </BrowserRouter>
        </SectionAnimationProvider>
      </PopupProvider>
    </div>
  );
}

export default App;